import { addQueryParamsToUrl, parseDataLink } from "../Utils/utilFunctions";
import { getCookie } from "./AuthService";
import axonApi from "./AxonApi";
import { clearData } from "./UltilsService";

export const fetchAulasByEstado = async (idServicio, estado) => {
  const idCurso = idServicio == 10 ? 86 : idServicio;
  const res = await axonApi.get(
    `/academico/cursos/${idCurso}/aulas?estado=${estado}`
  );

  if (res.data.error) {
    return [];
  }

  return res.data;
};

export const generateLink = async (data, grupo = null) => {
  let urlLink = '/checkout/venta';

  if (!data.email) {
    let url = `https://checkoutv4.axontraining.com/?idServicio=${data.idServicio}&idPais=${data.idPais}`;

    if (data.idAula) url += `&idAula=${data.idAula}`;

    if (data.usuarioResponsable)
      url += `&responsable=${data.usuarioResponsable}`;

    return {
      url: url,
      status: 200,
    };
  }

  try {
    data.idServicio 
    const res = await axonApi.post(urlLink, clearData(data));
    if ((res && res.data?.code == 200)) {
      return {
        status: res.status,
        url: res.data.data.url
      };
    }
    console.log('eh')
    return {
      status: 400,
      message: res.data.data.message
    }
  } catch (error) {
    if (error.response) {
      return {
        status: error.response.status,
        message: error.response.data?.message ?? 'Error'
      };
    }
  }
};

// export const generateLinkLP = async (data) => {
//   let url = "https://axontraining.com/cursos/carrera-de-coaching-icf";
//   url += "?inscripcion";
//   url += "&tag=linkVendedor";

//   // Cuando no conoce el email
//   if (!data.idVenta) {
//     data.responsable = data.operador;

//     delete data.sinEmail;
//     delete data.idContacto;
//     delete data.operador;
//     delete data.email;

//     return addQueryParamsToUrl(url, clearData(data));
//   }

//   // Cuando conoce el email
//   if (!data.idContacto) {
//     const res = await axonApi.get(
//       `internos/crm/usuarios?email=${data.email}&userType=contacto`
//     );

//     data.idc = res.data[0].id;
//   } else {
//     data.idc = data.idContacto;
//   }

//   if (data.email && data.idVenta) {
//     try {
//       const res = await axonApi.post(
//         `/internos/crm/ventas/${data.idVenta}/plan-cuotas-lp`
//       );
//     } catch (error) {
//       throw error.response;
//     }
//   }

//   data.responsable = data.operador;
//   delete data.idContacto;
//   delete data.operador;
//   delete data.email;
//   delete data.sinEmail;

//   return addQueryParamsToUrl(url, clearData(data));
// };
export const generateLinkLP = async (data) => {
  const token = await getCookie("token_empleados");
  delete data.idContacto;
  if (data.email && data.idVenta) {
    try {
      let res = await axonApi.post(
        `/internos/crm/landing-page`,
        data,
        {
          headers: {
            Authorization:
            `Bearer ${token}`,
          },
        }
      );
      return res.data.data.url;
    } catch (error) {
      throw error.response;
    }
  }
  return 'Error Generando el Link';
};
